import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Home } from 'lucide-react';
import { Button } from '@components/ui';
import { quickAccessApi } from './api';

/**
 * زر «الوصول السريع» في الشريط العلوي (بجانب جرس الإشعارات). سلوكه:
 *  - شاشة رئيسية (is_home) موجودة ⇒ يفتحها.
 *  - وإلا شاشة واحدة فقط مُسنَدة ⇒ يفتحها مباشرة.
 *  - وإلا (عدّة شاشات) ⇒ يفتح المُشغّل.
 * يختفي تماماً إن لم تكن للمستخدم أي شاشة.
 */
export function QuickAccessHomeButton() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const { data } = useQuery({
    queryKey: ['qa-mine'],
    queryFn: quickAccessApi.mineList,
    staleTime: 60_000,
  });
  const screens = data?.data || [];

  if (screens.length === 0) return null;

  const go = () => {
    const home = screens.find((s) => s.is_home);
    const target = home ? home._id : screens.length === 1 ? screens[0]._id : null;
    navigate(target ? `/quick-access/view/${target}` : '/quick-access');
  };

  const label = isRtl ? 'الوصول السريع' : 'Quick access';

  return (
    <Button variant="ghost" size="icon" onClick={go} aria-label={label} title={label}>
      <Home className="h-5 w-5" />
    </Button>
  );
}
